import http from './http';

const URL_ROOT = '/comuni';

export const getListMunicipalities = async () => {
  const response = await http.get(URL_ROOT);
  return response.data;
};
